import React, { Component } from 'react'
import { FormGroup, FormControl } from 'react-bootstrap'
import S from 'shorti'
import ListingSearch from '../ListingSearch'
const { NODE_ENV, BUILDING } = process.env
class LayoutsBar extends Component {
  getAsset(asset) {
    const url = (NODE_ENV === 'development' || BUILDING === 'true') ?
      require(`../../Templates/light/assets/images/${asset}`) :
      `/images/${asset}`
    return url
  }
  selectTemplate(id) {
    this.props.selectTemplate(id)
  }
  isSelectedTemplate(id) {
    const data = this.props.data
    if(data.selected_template === id)
      return true
    return false
  }
  handleMLSInputChange(e) {
    this.props.seachListings(e.target.value)
  }
  getAgentTemplates() {
    return (
      <div style={ S(`pull-left pointer w-150 h-200 mr-20 mb-20 relative`) }>
        <div onClick={ this.selectTemplate.bind(this, 'light') } style={ S(`${this.isSelectedTemplate('light') ? ' border-3-solid-2196f3' : ''} bg-url(${this.getAsset('4.png')} bg-cover bg-center relative mb-10 w-100p h-100p`) }></div>
        <div style={ S('color-8696a4 font-12') }>LIGHT</div>
        <div className="clearfix"></div>
      </div>
    )
  }
  handleListingClick(listing) {
    this.props.selectListing(listing)
  }
  handleRemoveSearchButtonClick() {
    this.props.removeSearchListings() 
  }
  getListingTemplates() {
    const data = this.props.data
    const listings_area_style = {
      overflowY: 'scroll',
      ...S('w-360 maxh-300 bg-fff color-333 absolute t-120 z-100')
    }
    let listing_area
    let close_search_button
    if (data.listings) {
      listing_area = (
        <div style={ listings_area_style }>
          <ListingSearch listings={ data.listings } handleListingClick={ this.handleListingClick.bind(this) }/>
        </div>
      )
      close_search_button = (
        <div style={ S('absolute t-9 r-10 pointer') } onClick={ this.handleRemoveSearchButtonClick.bind(this) }>&times;</div>
      )
    }
    return (
      <div>
        <FormGroup controlId="layouts">
          <div style={ S('relative') }>{ close_search_button }</div>
          <FormControl style={ S('h-42 font-15 bg-263445 border-2-solid-4e5c6c color-fff') } componentClass="input" placeholder="Search MLS# or Address" onChange={ this.handleMLSInputChange.bind(this) } onFocus={ this.handleMLSInputChange.bind(this) } value={ data.mls_input_value }/>
          <div style={ S('color-8696a4 font-12 mt-10') }>Input your MLS ID to see real info populated in these layouts. You can always input the MLS ID later once you choose a layout.</div>
        </FormGroup>
        { listing_area }
        <div style={ S(`pull-left pointer mr-20 mb-20 relative`) }>
          <div onClick={ this.selectTemplate.bind(this, 'clean') } style={ S(`w-150 h-200${this.isSelectedTemplate('clean') ? ' border-3-solid-2196f3' : ''} bg-url(${this.getAsset('3.png')} bg-cover bg-center relative mb-10`) }></div>
          <div style={ S('color-8696a4 font-12') }>CLEAN</div>
        </div>
      </div>
    )
  }
  changeLayoutsView(e) {
    const layout = e.target.value
    this.props.selectProduct(layout)
  }
  render() {
    const data = this.props.data
    if (!data)
      return <div></div>
    if (!data.show_listing_templates && !data.show_agent_templates)
      data.show_agent_templates = true
    const main_style = S('fixed p-20 mt-70 w-400 h-100p l-0 t-0 bg-263445 color-fff z-2')
    return (
      <div style={ main_style }>
        <FormGroup controlId="layouts">
          <FormControl style={ S('h-42 font-15') } onChange={ this.changeLayoutsView.bind(this) } componentClass="select" placeholder="select">
            <option selected={ data.show_agent_templates ? true : false } value="agent_websites">Agent Websites</option>
            <option selected={ data.show_listing_templates ? true : false } value="listing_websites">Listing Websites</option>
          </FormControl>
        </FormGroup>
        { data.show_agent_templates ? this.getAgentTemplates() : '' }
        { data.show_listing_templates ? this.getListingTemplates() : '' }
      </div>
    )
  }
}
export default LayoutsBar


// WEBPACK FOOTER //
// ./src/components/Partials/LayoutsBar/index.js